import cn from "classnames";

import type { ReactNode } from "react";

import { StatusIcon } from "@/components/statusIcon/statusIcon.component";
import { Text } from "@/components/text/text.component";

import {
  FEATURE_BLOCK_STYLE_CONFIG,
  getFeatureBlockTextClassName,
  type FeatureBlockStyleValue,
} from "./featureBlockStyles.config";

export function FeatureBlockContent({
  style,
  isListItem,
  children,
}: FeatureBlockContentProps) {
  const config = FEATURE_BLOCK_STYLE_CONFIG[style];

  if (isListItem) {
    return (
      <Text component="div" className={getFeatureBlockTextClassName(config)}>
        {children}
      </Text>
    );
  }

  return (
    <div
      className={cn(
        "flex w-full items-start gap-3 max-lg:text-left!",
          {
          "rich-text-feature-thin-check [&+[data-testid=text]]:pl-9 [&+p]:pl-9": style === "featureThinCheck"
          },
      )}>
      <StatusIcon variant={config.variant} srOnlyLabel={config.srOnlyLabel} />
      <Text component="div" className={getFeatureBlockTextClassName(config)}>
        {children}
      </Text>
    </div>
  );
}

type FeatureBlockContentProps = {
  style: FeatureBlockStyleValue;
  isListItem: boolean;
  children: ReactNode;
};
